<template>
    <div class="container">
        <div class="name">品种</div>
        <div class="content">
            <div class="content-item" v-for="(item, index) in list" :key="index"
                :class="{ active: currentIndex === index }" @click="handleClick(index)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentIndex: 0,
            list: [
                {
                    name: '全部',
                    id: 0
                },
                {
                    name: '品种1',
                    id: 1
                },
                {
                    name: '品种2',
                    id: 2
                }
            ]
        }
    },
    methods: {
        handleClick(index) {
            this.currentIndex = index
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    height: 50px;
    background-color: transparent;
    display: flex;
    padding-left: 20px;
    align-items: center;

    .name {
        font-weight: bold;
        font-size: 22px;
        color: #FFFFFF;
        margin-right: 16px;
    }

    .content {
        display: flex;
        overflow-x: scroll;

        &::-webkit-scrollbar {
            display: none;
        }
        width: calc(100vw - 40px - 48px - 20px);
    }

    .content-item {
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        min-width: 130px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 32, 67, 0.6);
        box-shadow: inset 0px 0px 14px 0px #0691ED;
        border-radius: 0px 0px 0px 0px;
    }

    .content-item.active {
        font-weight: bold;

        background: linear-gradient(270deg, #00A1FF 0%, #006AFF 100%);
        box-shadow: inset 0px 0px 14px 0px #0691ED;
        border-radius: 0px 0px 0px 0px;
    }
}
</style>